__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "doubts-and-materials";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@plurall/elo-beta", "2.0.0-beta.523", () => (Promise.all([__webpack_require__.e(86), __webpack_require__.e(283), __webpack_require__.e(805), __webpack_require__.e(205), __webpack_require__.e(768), __webpack_require__.e(227)]).then(() => (() => (__webpack_require__(90405))))));
			register("@plurall/use-person-assistent", "1.0.9", () => (__webpack_require__.e(764).then(() => (() => (__webpack_require__(13764))))));
			register("@sentry/react", "7.119.1", () => (Promise.all([__webpack_require__.e(722), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(14722))))));
			register("client-oauth2", "4.3.3", () => (__webpack_require__.e(710).then(() => (() => (__webpack_require__(26710))))));
			register("crypto-js", "4.2.0", () => (Promise.all([__webpack_require__.e(396), __webpack_require__.e(477)]).then(() => (() => (__webpack_require__(21396))))));
			register("dompurify", "3.4.17", () => (__webpack_require__.e(997).then(() => (() => (__webpack_require__(84997))))));
			register("graphql-tag", "2.12.6", () => (Promise.all([__webpack_require__.e(222), __webpack_require__.e(50)]).then(() => (() => (__webpack_require__(83222))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(5556))))));
			register("query-string", "6.14.1", () => (__webpack_require__.e(663).then(() => (() => (__webpack_require__(86663))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-infinite-scroller", "1.2.6", () => (Promise.all([__webpack_require__.e(283), __webpack_require__.e(805), __webpack_require__.e(420)]).then(() => (() => (__webpack_require__(81420))))));
			register("react-lottie", "1.2.10", () => (Promise.all([__webpack_require__.e(49), __webpack_require__.e(283), __webpack_require__.e(805)]).then(() => (() => (__webpack_require__(73049))))));
			register("react-responsive", "10.0.1", () => (Promise.all([__webpack_require__.e(283), __webpack_require__.e(805), __webpack_require__.e(431)]).then(() => (() => (__webpack_require__(14431))))));
			register("react-responsive", "9.0.2", () => (Promise.all([__webpack_require__.e(790), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(65790))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(666), __webpack_require__.e(283), __webpack_require__.e(805)]).then(() => (() => (__webpack_require__(76666))))));
			register("react-router-prop-types", "1.0.5", () => (Promise.all([__webpack_require__.e(805), __webpack_require__.e(760)]).then(() => (() => (__webpack_require__(91760))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			initExternal(75533);
			initExternal(81811);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};